import { Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "components/button/default";
import Package from "./package";
import { useAuthContext } from "components/context/authContext";
import { modalControl, priceFormat, successControl } from "util/commAction";
import { IRm, IRmOp } from "interface/book";
import { useMutation } from "@tanstack/react-query";
import { rmOpApi } from "components/api/book";
import { useLocation } from "react-router-dom";
import proImage from "assets/image/book_dflt_prd_item.png";
import RmDetail from "./detail";
import {
  BookInfProvider,
  useBookInfContext,
} from "components/context/bookInfContext";
import "../step1.scss";
import Image from "components/image";

type IRmProps = {
  rmInf: IRm;
};

export default function RmItem({ rmInf }: IRmProps) {
  const { t } = useTranslation();
  const { viewPort } = useAuthContext();
  const { bookInf } = useBookInfContext();
  const { state } = useLocation();
  const packageRef = useRef<HTMLDivElement>(null);

  const [packages, setPackages] = useState<IRmOp[]>([]);

  const packageMutation = useMutation({
    mutationFn: rmOpApi,
    onSuccess: (res) => {
      if (res) {
        const { status, data } = res;
        successControl({
          status,
          success() {
            setPackages(data.rmOpList);
          },
        });
      }
    },
  });

  const handleGetRmOps = () => {
    //패키지 리스트
    let params = {} as any;
    // if (state) {
    //   const { rmCnt, adltCnt, childCnt, dates } = state;
    //   params = {
    //     lodNo: rmInf.lodNo,
    //     rmNo: rmInf.rmNo,
    //     resvSDt: dates[0],
    //     resvEDt: dates[1],
    //     resvRmCt: rmCnt,
    //     adltPerCt: adltCnt,
    //     chldPerCt: childCnt,
    //   };
    // }
    if (bookInf.dates) {
      const { dates, rmCnt, adltCnt, childCnt } = bookInf;
      params = {
        lodNo: rmInf.lodNo,
        rmNo: rmInf.rmNo,
        resvSDt: dates[0],
        resvEDt: dates[1],
        resvRmCt: rmCnt,
        adltPerCt: adltCnt,
        chldPerCt: childCnt ?? 0,
      };
    }

    packageMutation.mutate(params);
  };

  const handleRmOpOpen = () => {
    if (packageRef.current) {
      const clientHeight = 60; //parent.children[1].children[0].clientHeight;

      const height =
        viewPort?.screen === "web"
          ? clientHeight * packages.length + (packages.length > 0 ? 100 : 120)
          : clientHeight * packages.length + (packages.length > 0 ? 40 : 80);

      const paddingBlock = viewPort?.screen === "web" ? 2 : 1.25;

      packageRef.current.style.height = height + "px";
      packageRef.current.style.paddingBlock = paddingBlock + "rem";
      packageRef.current.style.marginBottom = 1.5 + "rem";
      packageRef.current.style.border = "none";
      packageRef.current.className = "show";
    }
  };
  const handleRmOpClose = (parent: HTMLDivElement) => {
    parent.style.height = 0 + "px";
    parent.style.paddingBlock = 0 + "px";
    parent.style.margin = 0 + "px";
    parent.style.border = "none";
    parent.className = "";
  };

  useEffect(() => {
    handleRmOpOpen();
  }, [packages]);

  return (
    <>
      <div className="rm-item">
        <div className="item-inf">
          <div className="item-img">
            <Image src={rmInf.thumImgPhUrl} alt="객실 썸네일" />

            <Button
              text={t("btn_prsInf_bk")}
              styels="flex-1 bg-white transparent"
              onClick={(e) => {
                //객실정보 상세 보기
                modalControl({
                  isOpen: true,
                  styles: "p-4  md:p-8 max-w-[700px]",
                  chckBtn: false,
                  inner: (
                    <BookInfProvider>
                      <RmDetail rmPdNo={rmInf.rmPdNo} />
                    </BookInfProvider>
                  ),
                });
              }}
            />
          </div>
          <div>
            {viewPort?.screen === "web" && (
              <Fragment>
                <ul>
                  <li>
                    <h2 className="sub mb-1 ellipsis">{rmInf.rmNm}</h2>
                    <h6>
                      {t("txt_max_guests_bk")}&nbsp;{rmInf.minPerCt}/
                      {rmInf.maxPerCt}
                    </h6>
                  </li>
                  <li>
                    {rmInf.vatInYn === "Y" && <h6>{t("txt_desc_vat_bk")}</h6>}
                    <h6
                      className={
                        rmInf.sellPri !== rmInf.salePri ? "line-through" : ""
                      }
                    >
                      {priceFormat(rmInf.salePri)}
                    </h6>
                    <h2 className="sub text-blue-300">
                      {priceFormat(rmInf.minSellPri)} ~
                    </h2>
                  </li>
                </ul>
                <div className="flex gap-2">
                  <Button
                    text={t("btn_pck_bk")}
                    styels="w-[140px]"
                    onClick={(e) => {
                      //웹뷰 패키지 선택 뷰 show
                      const parent = e.currentTarget.closest("div.item-inf");
                      if (parent) {
                        const packageEl = parent.nextSibling as HTMLDivElement;
                        const styles = packageEl.className;
                        if (styles.includes("show")) {
                          handleRmOpClose(packageEl);
                        }
                        if (!styles.includes("show")) {
                          handleGetRmOps();
                          packageRef.current = packageEl;
                        }
                      }
                    }}
                  />
                  <Button
                    text={t("btn_prsInf_bk")}
                    styels="w-[140px] bg-white"
                    onClick={() => {
                      modalControl({
                        isOpen: true,
                        styles: "max-w-[700px] px-8",
                        chckBtn: false,
                        inner: (
                          <BookInfProvider>
                            <RmDetail rmPdNo={rmInf.rmPdNo} />
                          </BookInfProvider>
                        ),
                      });
                    }}
                  />
                </div>
              </Fragment>
            )}
            {viewPort?.screen === "mb" && (
              <>
                <ul>
                  <li>
                    <h3 className="ellipsis">{rmInf.rmNm}</h3>
                    <h6>
                      {t("txt_max_guests_bk")} {t("txt_max_guests_bk")}&nbsp;
                      {rmInf.minPerCt}/{rmInf.maxPerCt}
                    </h6>
                  </li>
                  <li className="between-center  border-tp-1 pt-3 mt-3">
                    <div>
                      {rmInf.vatInYn === "Y" && <h6>{t("txt_desc_vat_bk")}</h6>}
                      <h3 className="sub text-blue-300 p-0 m-0">
                        {" "}
                        {priceFormat(rmInf.minSellPri)} ~
                      </h3>
                    </div>
                    <Button
                      text={t("btn_pck_bk")}
                      styels="btn-icon-check"
                      onClick={(e) => {
                        //모발일 패키지 선택 뷰 show
                        const parent = e.currentTarget.closest(
                          "div.item-inf"
                        ) as HTMLDivElement;

                        if (parent) {
                          const packageEl =
                            parent.nextSibling as HTMLDivElement;
                          const styles = packageEl.className;
                          if (styles.includes("show")) {
                            handleRmOpClose(packageEl);
                            e.currentTarget.className = "btn btn-icon-check";
                          }
                          if (!styles.includes("show")) {
                            e.currentTarget.className =
                              e.currentTarget.className + " " + "rotate";
                            handleGetRmOps();
                            packageRef.current = packageEl;
                          }
                        }
                      }}
                    />
                  </li>
                </ul>
              </>
            )}
          </div>
        </div>
        <div>
          <Package packageList={packages} rmPdNo={rmInf.rmPdNo} />
        </div>
      </div>
    </>
  );
}
